import type { FC } from 'react'
import React from 'react'

import NumberBadge from '@vfuk/core-number-badge'

import type { IconProProps } from './IconPro.types'
import * as Styled from './styles/IconPro.style'

import { nonThemeableRules } from '../../ruleSet'

const IconPro: FC<IconProProps> = ({
  size = nonThemeableRules.defaultSize as number as IconProProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
  numberBadge,
}: IconProProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 24 24' xmlns='http://www.w3.org/2000/svg'>
        <g fill='none'>
          <path d='M18.508 14.625V2.531H5.539c-.023 0-.039.016-.039.04' vectorEffect='non-scaling-stroke' />
          <path
            d='M5.5 2.57v12.055c0 .77.336 1.602 1 2.473.586.77 1.418 1.558 2.469 2.343 1.312.977 2.386 1.704 3.035 2.036.652-.332 1.723-1.059 3.035-2.036 1.055-.785 1.883-1.574 2.469-2.343.664-.875 1-1.703 1-2.473'
            vectorEffect='non-scaling-stroke'
          />
          <path d='m8 8 4-2 4 2m-8 3 4-2 4 2m-8 3 4-2 4 2' vectorEffect='non-scaling-stroke' />
        </g>
      </svg>
      <If condition={numberBadge}>
        <Styled.NumberBadgeContainer>
          <NumberBadge number={numberBadge!} appearance={inverse ? appearance : 'primary'} />
        </Styled.NumberBadgeContainer>
      </If>
    </Styled.IconWrapper>
  )
}

export default IconPro
